import { ButtonComponent } from 'baseComponents/ButtonComponent';
import { TableComponent } from 'baseComponents/TableComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { AdminErrorPage } from 'components/AdminErrorPage';
import { TestUserType, useGetTestUsers } from 'hooks/useGetTestUsers';
import { useEffect, useState } from 'react';
import { ColumnsType } from 'antd/es/table';
import { useLocation, useNavigate } from 'react-router';
import { useDeleteTestUser } from 'hooks/useDeleteTestUser';
import { Spin, notification } from 'antd';

const columns: ColumnsType<TestUserType> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
  },
  {
    title: 'Nickname',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: 'FO Name',
    dataIndex: 'franchise_owner_name',
    key: 'franchise_owner_name',
  },
];

export const AdminManageTestUsersPush = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [api, contextHolder] = notification.useNotification();
  const [selectedUsersIds, setSelectedUsersIds] = useState<
    TestUserType['id'][]
  >([]);

  useEffect(() => {
    if (location.state === 'success') {
      return api.success({
        message: 'Test user invited',
        description: `User has been successfully invited.`,
        duration: 3,
      });
    } // eslint-disable-next-line
  }, []);

  const {
    data = [],
    isLoading,
    isRefetching,
    isError,
    error,
    refetch,
  } = useGetTestUsers('push');

  const { mutate: deleteUsers, isPending: isDeletePending } = useDeleteTestUser(
    {
      onSuccess: () => {
        refetch();
        return api.success({
          message: 'User removed',
          description: `User has been successfully removed.`,
          duration: 3,
        });
      },
      onError: () => {
        return api.error({
          message: 'Remove user error',
          description: `Failed to remove user. Please try again later.`,
          duration: 3,
        });
      },
    }
  );

  if (isError) {
    return (
      <AdminErrorPage
        isRefetching={isRefetching}
        refetch={refetch}
        error={error.response?.data?.message || 'Error fetching test users'}
      />
    );
  }

  return (
    <AdminPageWrapper>
      {contextHolder}
      <TableComponent
        loading={isLoading || isRefetching}
        tableName='Manage Test Users Push'
        dataSource={data}
        total={data.length}
        columns={columns}
        selectable
        selectionType='radio'
        rowKey={(record) => record.id}
        onSelection={(userIds) => {
          setSelectedUsersIds(userIds as TestUserType['id'][]);
        }}
        ctaButtons={
          <>
            <Spin spinning={isDeletePending}>
              <ButtonComponent
                label='Delete'
                onClick={() => {
                  // always a single user selected
                  if (selectedUsersIds.length === 1) {
                    deleteUsers(selectedUsersIds[0]);
                  }
                }}
                appereance='secondary'
                size='middle'
                style={{ maxWidth: 320 }}
                fullWidth
                disabled={selectedUsersIds.length === 0}
              />
            </Spin>
            <ButtonComponent
              label='Add new'
              onClick={() => {
                navigate('/admin/manage/test-users-push/add');
              }}
              appereance='primary'
              size='middle'
              style={{ maxWidth: 320 }}
              fullWidth
            />
          </>
        }
      />
    </AdminPageWrapper>
  );
};
